import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(_) {
        return { hasError: true, error: _ };
    }
    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }
    render() {
        var _a;
        if (this.state.hasError) {
            return (_jsxs("div", { className: "wpqt-flex wpqt-h-screen wpqt-items-center wpqt-justify-center wpqt-text-center wpqt-text-lg", children: [__("Something went wrong. Please refresh the page.", "quicktasker"), _jsx("br", {}), (_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
